import { Component, OnInit, ViewChild } from "@angular/core";
import { env } from "@environments/environment";
import { authConfig } from "@app/oauth/auth.config";
import { OAuthService } from "angular-oauth2-oidc";
import { MenuItem } from "primeng/api/menuitem";
import { Router } from "@angular/router";
import { BasketService } from "@app/components/basket/basket.service";
import { DataService } from "@app/services/data.service";
import { AccountService } from "@app/services/account.service";
import { Dropdown } from "primeng/dropdown";
import { SearchController } from "@app/ui_controllers/searchController";
import { SearchService } from "@app/services/search.service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
})
export class HeaderComponent implements OnInit {
  constructor(public oauthSvc: OAuthService,
              public accountService: AccountService,
              public basketService: BasketService,
              public dataService: DataService,
              public searchService: SearchService,
              private readonly searchController: SearchController,
              private router: Router) {}
  eStockHomePage = env.eStockHomePage;
  items: MenuItem[] = [];
  // selectedValue: string | undefined;
  // searchInProgress = false;
  @ViewChild("dd") dropdown!: Dropdown;
  // quickSearchResults: { label: string; value: string; items: any[]; }[] = [];

  ngOnInit(): void {
    this.items = [
      {
        label: "Вихід",
        icon: "pi pi-fw pi-power-off",
        command: () => {
          this.logout();
        },
      },
    ];
  }

  goToBasket(): void {
    if (this.basketService.basketItems.size > 0) {
      this.router.navigate(["/basket"]);
    }
  }

  logout() {
    authConfig.redirectUri = `${location.origin}${location.pathname}`;
    this.oauthSvc.redirectUri = `${location.origin}${location.pathname}`;
    this.oauthSvc.logOut();
  }

  onChange($event: any) {
    this.dropdown.show();
    this.searchService.quickSearch($event);
  }

  onSearchIconClick() {
    this.searchService.page = 0;
    this.searchService.content = [];
    this.searchService.search();
    this.dropdown.hide();
    this.router.navigate(["/search"], { queryParams:
        { searchTerm: this.searchService.searchTerm }
    });
  }
}

export const mockData = [
  {
    label: "Розподіли",
    value: "dist",
    items: [
      { label: "Розподіл №1", value: "Розподіл №1" },
      { label: "Розподіл №6", value: "Розподіл №6" },
      { label: "Розподіл №3", value: "Розподіл №3" },
      { label: "Розподіл №477", value: "Розподіл №477" },
    ],
  },
  {
    label: "Поставки",
    value: "supplies",
    items: [
      { label: "Поставка №1", value: "Поставка №1" },
      { label: "Поставка №111", value: "Поставка №111" },
      { label: "Поставка №49", value: "Поставка №49" },
      { label: "Поставка №8", value: "Поставка №8" },
    ],
  },
];
